module.exports = __webpack_public_path__ + "static/media/stat-trak-icon.2e0b2cd0.png";